import { Meta } from '@angular/platform-browser';
import { AppConfigService } from './app-config.service';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/platform-browser";
import * as i3 from "./app-config.service";
var SEOService = /** @class */ (function () {
    function SEOService(dom, meta, appConfigService) {
        this.dom = dom;
        this.meta = meta;
        this.appConfigService = appConfigService;
    }
    SEOService.prototype.addTags = function (metaData) {
        var _this = this;
        var meta = this.mapServerModel(metaData);
        meta.forEach(function (metaItem) {
            var selector = metaItem.name ? "name=" + metaItem.name : "property='" + metaItem.property + "'";
            _this.meta.updateTag(metaItem, selector);
        });
        var microdataEl = this.dom.querySelector('[type="application/ld+json"]');
        if (metaData && metaData.microdata && metaData.microdata.value) {
            var value = metaData.microdata.value.replace(/\\"/g, "'").replace(/\"/g, "").replace(/\\n/g, "");
            this.dom.querySelector("body").insertAdjacentHTML("beforeend", value);
        }
        if (microdataEl) {
            microdataEl.remove();
        }
    };
    SEOService.prototype.addCanonicalURL = function (url) {
        var link = this.dom.querySelector('[rel="canonical"]');
        if (!link) {
            link = this.dom.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.dom.head.appendChild(link);
        }
        var href = url.indexOf("://") > -1 ? url : this.appConfigService.getHostName() + url;
        link.setAttribute('href', href);
    };
    SEOService.prototype.mapServerModel = function (metaData) {
        var meta = [];
        if (!metaData)
            return meta;
        if (metaData.metaTitle)
            meta.push({ name: 'title', content: metaData.metaTitle.value || '' });
        if (metaData.metaDescription)
            meta.push({ name: 'description', content: metaData.metaDescription.value || '' });
        if (metaData.socialTitle)
            meta.push({ property: 'og:title', content: metaData.socialTitle.value || '' });
        if (metaData.socialDescription)
            meta.push({ property: 'og:description', content: metaData.socialDescription.value || '' });
        if (metaData.socialImage)
            meta.push({ property: 'og:image', content: get(metaData, "socialImage.value.sources[0].srcSet", '') });
        return meta;
    };
    SEOService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SEOService_Factory() { return new SEOService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.Meta), i0.ɵɵinject(i3.AppConfigService)); }, token: SEOService, providedIn: "root" });
    return SEOService;
}());
export { SEOService };
